import { submitLabOrder } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  SubmitLabOrderRequestT,
  SubmitLabOrderResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchSubmitLabOrder(
  userId: string,
  request: SubmitLabOrderRequestT,
  signal?: AbortSignal
): Promise<SubmitLabOrderResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await submitLabOrder(userId, request, config);
  return lotusHealthZod.submitLabOrderResponse.parse(response.data) as SubmitLabOrderResponseT;
}
